import {Applicant} from "./Applicant";
import {Declaration} from "./Declaration";
import {PriorCourse} from "./PriorCourse";
import {MonashCourse} from "./MonashCourse";
import {PriorLearning} from "./PriorLearning";
import {PriorCourseUnit} from "./PriorCourseUnit";

export class Application {
    public id: string;
    public websafeKey: string;
    public applicant: Applicant;
    public owningFacultyCode: string;
    public coursesApplied: MonashCourse[];
    public priorStudies: PriorCourse[];
    public priorLearning: PriorLearning;
    public declaration: Declaration;
    public created: string;
    public updated: string;
    public status: string;
    public archived: boolean;
    public descriptiveStatus: string;
    public submittedDate: string;
    public approvedDate: string;
    public outcomeComment: string;
    public supportingDocuments: any[];
    public supportingLinks: string[];
    public internalUseOnlyDocuments: any[];
    public centralAdmissionsManaged: boolean;
    public adjustedCourseDuration: string;
    public assessPriorStudies: boolean;
    public isOnlineCourse: boolean;
    public govCreditBasis: string;
    public isNewAppAfterVersion2: boolean;
    public isPendingStudentAction: any;
    public courseDocuments: Map<string, any[]>;

    public static createDummyApplication(fromApp: Application) {

        const application = new Application();

        application.applicant = fromApp.applicant;

        const monashCourse = new MonashCourse();
        monashCourse.courseCode = "PHYS001";
        monashCourse.courseName = "Nuclear physics";
        monashCourse.campus = "Clayton";
        monashCourse.major = "Charm quark in everyday life";
        application.coursesApplied = [monashCourse];

        const priorStudy = new PriorCourse();
        priorStudy.country = "country";
        priorStudy.institution = "institution";
        priorStudy.courseName = "courseName";
        priorStudy.yearCompleted = 2007;
        priorStudy.units = [];

        const priorStudyUnitIndexes = [1, 2, 3, 4, 5];
        for (const index of priorStudyUnitIndexes) {
            const priorStudyUnit = new PriorCourseUnit();
            priorStudyUnit.unitCode = `unitCode${index}`;
            priorStudyUnit.unitTitle = `unitTitle ${index}`;
            priorStudyUnit.yearCompleted = 2007;

            priorStudy.units.push(priorStudyUnit);
        }

        application.priorStudies = [priorStudy];

        const priorLearning = new PriorLearning();
        priorLearning.details = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
Duis non tellus quis lorem bibendum pellentesque. Proin egestas non odio dapibus egestas. 
Donec molestie tellus tellus, sit amet elementum justo dapibus sed. 
Nunc sit amet purus non enim venenatis mollis. Nullam id rutrum nibh, sit amet faucibus purus. 
Donec ex lorem, pulvinar sed tellus ac, porttitor vehicula orci. Sed pretium ornare maximus. 
Nunc condimentum sapien et blandit porttitor. Aliquam vel quam nisl. Suspendisse potenti.`
            .replace(/(\r\n|\n|\r)/gm, "") // replace new lines
        ;
        priorLearning.professionalDevelopmentCertificate = true;
        priorLearning.letterFromEmployer = true;
        priorLearning.personalStatement = true;
        priorLearning.currentCV = true;
        priorLearning.positionDescription = true;

        application.priorLearning = priorLearning;


        const declaration = new Declaration();
        declaration.abideMonashPolicy = true;
        declaration.authoriseToObtainFurtherInformation = true;
        declaration.completeAndCorrectInformation = true;
        declaration.consentToAudit = true;
        declaration.consentToDiscloseInformation = true;
        declaration.haveReadPrivacyStatement = true;
        declaration.agreeToDeclaration  = true;

        application.declaration = declaration;


        return application;
    }

    public static initValues(application: Application): Application {
        if (application.applicant == null) {
            application.applicant = new Applicant();
        }

        if (application.coursesApplied == null || application.coursesApplied.length === 0) {
            application.coursesApplied = [];
        }

        if (application.priorStudies == null || application.priorStudies.length === 0) {
            application.priorStudies = [];
        }

        if (application.priorLearning == null) {
            application.priorLearning = new PriorLearning();
        }

        if (application.declaration == null) {
            application.declaration = new Declaration();
        }

        if (application.supportingDocuments == null) {
            application.supportingDocuments = [];
        }

        if (application.internalUseOnlyDocuments == null) {
            application.internalUseOnlyDocuments = [];
        }

        return application;
    }

    constructor() {
        Application.initValues(this);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/model/Application.ts